/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_Example_Tool_2Inputs */

const en_mk_tb_example_tool_2 = /** @type {(inputs: Mk_Tb_Example_Tool_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test evidence submitted · teammate reviewing`)
};

const id_mk_tb_example_tool_2 = /** @type {(inputs: Mk_Tb_Example_Tool_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bukti tes dikirim · rekan sedang meninjau`)
};

/**
* | output |
* | --- |
* | "Test evidence submitted · teammate reviewing" |
*
* @param {Mk_Tb_Example_Tool_2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_example_tool_2 = /** @type {((inputs?: Mk_Tb_Example_Tool_2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_Example_Tool_2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_example_tool_2(inputs)
	return en_mk_tb_example_tool_2(inputs)
});